import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from "@angular/router";
import {NavigationService} from "../navigation/navigation.service";
import {DetailService} from "./detail.service";
import {HttpParams} from "@angular/common/http";


/**
 * Class DetailResolver
 */
@Injectable()
export class DetailResolver
{

	/**
	 * Function > constructor
	 * @param navigation_service
	 * @param router
	 * @param detail_service
	 */
    constructor (
        private navigation_service: NavigationService,
        private router: Router,
        private detail_service: DetailService
        )
    {} // end function constructor


	/**
	 * @param route
	 * @param state
	 */
    resolve (route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
	{
        let route_menu = route.parent.paramMap.get("route_menu");

        let route_submenu = route.paramMap.get("route_submenu");

        // In verschachteltem Listing
		let listing_id = route.paramMap.get("listing_id");

		// Bulkinsert?
		let bulk = route.queryParamMap.get("bulk");

		// Neuanlegen von nested_listing, da data-parameter gesetzt, Listing-ID aber undefinded ist
		let create_new = route.data.BOO_nested_listing && !listing_id;

		// Spezielle Config, die nicht allein via route bestimmt werden kann
		let config = route.queryParamMap.get("config");

		// Detailansicht
		let config_endpoint = this.navigation_service.getDetailConfigEndpointByRoute(route_menu, route_submenu, listing_id,config);

		// Falls Bulkinsert lade spezielle konfig
		if(bulk && this.navigation_service.hasBulkinsert(route_menu, route_submenu))
		{
			config_endpoint = this.navigation_service.getBulkinsertConfigEndpointByRoute(route_menu, route_submenu);
		} // end if

		let content_endpoint;

		let http_content_params = new HttpParams();
        // Soll neues Element angelegt werden?
        if (route.paramMap.get("id") === "new" || create_new)
        {
            content_endpoint = this.navigation_service.getDataEndpointByRoute(route_menu, route_submenu, listing_id, true);
			http_content_params = this.navigation_service.getDataEndpointParamsByRoute(route_menu, route_submenu);
        }
        else if(this.detail_service.STR_detailurl)
        {
        	// Contentendpoint aus Listingdata wurde in Variable STR_detailurl zwischengespeichert
            content_endpoint = this.detail_service.STR_detailurl;
			http_content_params = this.navigation_service.getDataEndpointParamsByRoute(route_menu, route_submenu)
        }
		else
		{
        	// Behelf, um Seite auch nach Reload anzuzeigen
			content_endpoint = 	this.navigation_service.getDataEndpointByRoute(route_menu, route_submenu, listing_id, false);

			content_endpoint += "/" + route.paramMap.get("id");
			http_content_params = this.navigation_service.getDataEndpointParamsByRoute(route_menu, route_submenu)

		} // end if

        return this.detail_service.getFormFields(config_endpoint, content_endpoint,http_content_params);

	} // end function resolve

} // end class DetailResolver
